import axios from "axios";
import {API_HOST} from "@/core/variables";

class AdminSettingRepository {
    async read() {
        return axios.get(`${API_HOST}/v1/admin-settings/default`, )
    };

    async create(defaultChatWorkflowId: string, defaultKeywordClusterWorkflowId: string) {
        return axios.post(`${API_HOST}/v1/admin-settings`, {
            defaultChatWorkflowId,
            defaultKeywordClusterWorkflowId
        })
    };
}

const adminSettingRepository = new AdminSettingRepository();
export default adminSettingRepository;